module.exports = __webpack_public_path__ + "6eab019ed6c780cf87567124b794870c.svg";